import OptionalSettings from "../../../../src/components/optional-settings";
import * as React from 'react';
export default {
  OptionalSettings,
  React
};